import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../../../prop-types/children';

import style from './tab-list-container.module.css';

export const TabListContainer = ({ children, className }) => {
  return <div className={classnames(style['tab-list-container'], className)}>{children}</div>;
};

TabListContainer.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
};
